import { useTheme } from "@mui/material/styles";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";


Page.Header = ({ title, subtitle, children, ...props }) => {
	const style = {
		root: {
			width: "100%"
		}
	};

	return (
		<Box.Column {...props} sx={{ ...style.root, ...props.sx }}>
			{title && <Typography variant="h1">{title}</Typography>}
			{subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
			{children}
		</Box.Column>
	);
};

Page.Body = ({ children, ...props }) => {
	const style = {
		root: {
			width: "100%"
		}
	};

	return (
		<Box.Column gap={1} sx={{ ...style.root, ...props.sx }}>
			{children}
		</Box.Column>
	);
};

export default function Page({ children, ...props }) {
	const theme = useTheme();
	const style = {
		root: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			gap: 1,
			p: theme.spacing(2.5, 2, 3.75),
			minHeight: "100%"
		}
	};

	return (
		<Container {...props} sx={{ ...style.root, ...props.sx }}>
			{children}
		</Container>
	);
}